import React from 'react';
import { WidgetIcon } from '@/components/WidgetIcon';
import { HeadsetIcon } from '@/components/HeadsetIcon';
import { useTranslation } from '@/lib/i18n';

interface ChatBubbleProps {
  isOpen: boolean;
  onClick: () => void;
  unreadCount: number;
  primaryColor?: string;
  iconStyle?: 'brand' | 'neutral' | 'dots' | 'rounded' | 'spark';
  chatMode?: 'sales' | 'support';
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  isOpen,
  onClick,
  unreadCount,
  primaryColor = '#006cd4',
  iconStyle = 'brand',
  chatMode = 'sales',
}) => {
  const { t } = useTranslation();
  return (
    <button
      className={`r3c-bubble ${isOpen ? 'r3c-bubble--open' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? t('chat.closeChat') : t('chat.openChat')}
      style={{ '--r3c-primary-color': primaryColor } as React.CSSProperties}
    >
      {isOpen ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ) : chatMode === 'support' ? (
        <HeadsetIcon className="r3c-bubble__icon r3c-bubble__icon--small r3c-bubble__icon--support" style={{ width: 28, height: 28, opacity: 1 }} />
      ) : iconStyle === 'brand' ? (
        <WidgetIcon iconStyle={iconStyle} className="r3c-bubble__icon" style={{ width: 40, height: 40, opacity: 1 }} />
      ) : (
        <WidgetIcon
          iconStyle={iconStyle}
          className={`r3c-bubble__icon r3c-bubble__icon--small${iconStyle === 'neutral' ? '' : ' r3c-bubble__icon--alt'}`}
          style={{ width: 28, height: 28, opacity: 1 }}
        />
      )}
      {unreadCount > 0 && !isOpen && (
        <span className="r3c-bubble__badge">{unreadCount}</span>
      )}
    </button>
  );
};
